import { Series } from '@radsource/ng-common-lib'
import { StudyInstance } from "./study-instance";
import { SOPInstance } from "./sop-instance";
import { PatientInstance } from "./patient-instance";
import { of } from "rxjs";
import { Injectable } from '@angular/core';

@Injectable()
export class SeriesInstance extends Series {

    //PROPERTIES
    new_series_instance_uid: string;
    number_of_series_related_instances: number;
    thumbnail: any;
    thumbnail$: any;
    patient: PatientInstance;
    study: StudyInstance;
    sops: Array<SOPInstance>;
    sops$: any;

    pushProgress: any;
    pushProgress$: any;

    //ui variables
    editTemplate: Boolean = false;
    editing: Boolean = false;
    saving: Boolean = false;
    deleting: Boolean = false;
    expanded: Boolean = false;
    expanded$: any;
    loadingThumbnail: Boolean = false;

    //CONSTRUCTOR
    constructor();
    constructor(
        instance: any
    );
    constructor(instance?: any) {
        super(instance);
        this.thumbnail = (instance && instance.thumbnail) ? instance.thumbnail : null;
        this.number_of_series_related_instances = (instance && instance.number_of_series_related_instances) ? instance.number_of_series_related_instances : 0;
        // this.misc = (instance && instance.misc) ? instance.misc : null;
        this.patient = (instance && instance.patient) ? new PatientInstance(instance.patient) : new PatientInstance();
        this.study = (instance && instance.study) ? new StudyInstance(instance.study) : new StudyInstance();
        this.sops = (instance && instance.sops) ? instance.sops : new Array<SOPInstance>();
        this.sops$ = of(this.sops);
        this.pushProgress = (instance && instance.pushProgress) ? instance.pushProgress : { state: 'QUEUED' };
        this.pushProgress$ = of(this.pushProgress);
    } //end constructor

    resetAllButThumbnail(): void {
        this.expanded = false;
        this.expanded$ = of(this.expanded);

        this.pushProgress = { state: 'QUEUED' };
        this.pushProgress$ = of(this.pushProgress);
    }

    update(inst: SeriesInstance): void {
        this.record_id = inst.record_id;
        this.study_record_id = inst.study_record_id;
        this.instance_uid = inst.instance_uid;
        this.new_series_instance_uid = inst.new_series_instance_uid;
        this.number = inst.number;
        this.date = inst.date;
        this.description = inst.description;
        this.modality = inst.modality;
        this.number_of_series_related_instances = inst.number_of_series_related_instances;
    }

    updateProgress(): void {
        let allSOPProgress = this.sops.map((sop) => {
            return { progress: sop.pushProgress, series_record_id: sop.series.record_id };
        });
        let failed = allSOPProgress.filter((pro) => pro.progress.state == 'FAILURE' && pro.series_record_id == this.record_id);
        let canceled = allSOPProgress.filter((pro) => pro.progress.state == 'CANCELED' && pro.series_record_id == this.record_id);
        let complete = allSOPProgress.filter((pro) => pro.progress.state == 'SUCCESS' && pro.series_record_id == this.record_id);
        let warned = allSOPProgress.filter((pro) => pro.progress.state == 'WARNED' && pro.series_record_id == this.record_id);

        this.pushProgress['sops_failed'] = failed.length;
        this.pushProgress['sops_canceled'] = canceled.length;
        this.pushProgress['sops_complete'] = complete.length;
        this.pushProgress['sops_warning'] = warned.length;

        this.calculatePushProgressState();
    }

    calculatePushProgressState(): void {
        if (this.pushProgress.sops_failed >= this.sops.length) {
            this.pushProgress['state'] = 'FAILURE';
        }
        else if (this.pushProgress.sops_canceled > 0) {
            this.pushProgress['state'] = 'CANCELED';
        } else if (this.pushProgress.sops_warning > 0) {
            this.pushProgress['state'] = 'WARNING';
        } else if (this.pushProgress.sops_complete >= this.sops.length) {
            this.pushProgress['state'] = 'SUCCESS';
        } else {
            this.pushProgress['state'] = 'QUEUED';
        }

        this.pushProgress$ = of(this.pushProgress);
    }

    essentials(): any {
        let essentials = {
            record_id: this.record_id,
            study_record_id: this.study_record_id,
            instance_uid: this.instance_uid,
            new_series_instance_uid: this.new_series_instance_uid,
            number: this.number,
            date: this.date,
            description: this.description,
            modality: this.modality,
            number_of_series_related_instances: this.number_of_series_related_instances
        };

        return essentials;
    }

} //end class
